export const LogActivityFormChunk = () => import(/* webpackChunkName: "logActivity" */ '../portlets/LogActivity');

export const AddLeadFormChunk = () => import(/* webpackChunkName: "addLead" */ '../portlets/AddLead');

export const AddContactFormChunk = () => import(/* webpackChunkName: "addContact" */ '../portlets/AddContact');

export const NumbersManagerChunk = () => import(/* webpackChunkName: "numbersManager" */ '../portlets/NumbersManager');

export const TranslationsManagerChunk = () => import(/* webpackChunkName: "TranslationsManager" */ '../portlets/TranslationsManager');
